import type { Action } from './actions';

/**
 * Actions pressed between two ticks, consumed once by the next tick.
 *
 * Several FLAP presses between the same two ticks give one impulse (a flap sets vy, so two would be
 * the same), but every press is counted in `flapPresses` for stats.flaps (GDD §5.5).
 */
export class ActionQueue {
  /** Total FLAP presses, including the ones coalesced into a single impulse. */
  flapPresses = 0;
  private pending: Action[] = [];

  enqueue(action: Action): void {
    if (action === 'FLAP') {
      this.flapPresses += 1;
      if (this.pending.includes('FLAP')) return;
    }
    this.pending.push(action);
  }

  /** Returns the pending actions in press order and empties the queue. */
  drain(): Action[] {
    const actions = this.pending;
    this.pending = [];
    return actions;
  }

  get size(): number {
    return this.pending.length;
  }
}
